export const tableFooterActionsStyle = {
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		position: 'fixed',
		gap: '24px',
		bottom: '24px',
		maxWidth: '1170px',
		width: '100%',
		height: '80px',
		padding: '0 100px',
		background: 'var(--neutral-100)',
		left: 'calc(50% - 585px)',
		borderRadius: '0 0 8px 8px',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	button: {
		height: '44px',
		fontWeight: 700,

		'&.MuiButton-outlinePrimary': {
			backgroundColor: 'var(--neutral-100)',

			'&:hover': {
				backgroundColor: 'var(--primary-100)',
				color: 'var(--primary-500)',
			},
		},
	},
};
